import { UploadFile } from 'antd/es/upload/interface';
import { FormInstance } from 'antd/lib/form';
import axios from 'axios';
import client from '@/lib/feathers';
import { Consumable } from '@/types/database/communityDevice';

const uploadFile = async (file: UploadFile) => {
  try {
    if (file.originFileObj) {
      const formData = new FormData();
      formData.append('files', file.originFileObj);
      const res = await axios.post('/newUploads', formData, {
        headers: {
          authorization: localStorage.getItem('feathers-jwt'),
        },
        params: {
          type: 'communityDevice',
        },
      });
      return res.data;
    } else {
      throw new Error('無可上傳檔案，請重新上傳');
    }
  } catch (err) {
    return err;
  }
};

const deleteFile = async (file: UploadFile) => {
  try {
    if (file.response) {
      await client.service('uploads').remove(file.response._id);
    } else {
      throw new Error('刪除舊檔案失敗，請重新整理頁面');
    }
  } catch (err) {
    return err;
  }
};

// 刪除舊檔案，更新新檔案
const updateFile = async (
  form: FormInstance,
  record: Consumable | undefined,
  paths: string[]
) => {
  try {
    for (const path of paths) {
      const newFileList = form.getFieldValue(path) || [];
      const oldFileList = record?.[path] || [];

      const updateFileList = async (file: UploadFile) => {
        const response = await uploadFile(file);
        const newFile = file;
        newFile.response = response;
        delete newFile.originFileObj;
        form.setFieldsValue({
          [path]: [newFile],
        });
      };

      if (newFileList.length === 0 && oldFileList.length !== 0) {
        deleteFile(oldFileList[0]);
      }
      if (newFileList.length !== 0 && oldFileList.length === 0) {
        await updateFileList(newFileList[0]);
      }
      if (newFileList.length !== 0 && oldFileList.length !== 0) {
        if (newFileList[0].uid !== oldFileList[0].uid) {
          deleteFile(oldFileList[0]);
          await updateFileList(newFileList[0]);
        }
      }
    }
  } catch (err) {
    return err;
  }
};

const handleDeleteDevice = async (record: Consumable) => {
  try {
    const files: UploadFile[] = [];
    if (Array.isArray(record.files)) {
      files.push(...record.files);
    }
    if (Array.isArray(record.specification)) {
      files.push(...record.specification);
    }
    const promises = files.map((file) => deleteFile(file));
    promises.push(client.service('communityDevice').remove(record._id));
    await Promise.all(promises);
  } catch (err) {
    return err;
  }
};

export { uploadFile, deleteFile, updateFile, handleDeleteDevice };
